export var RECENT_SEARCH_WIDTH_IN_PX = 420;
export var RECENT_SEARCH_WIDTH_WITHOUT_ITEMS_IN_PX = 360;
export var RECENT_SEARCH_HEIGHT_IN_PX = 360;
export var LINKPICKER_HEIGHT_IN_PX = 570;